import React from 'react';
import PropTypes from 'prop-types';
import {observer, inject} from 'mobx-react';
import {renderToStaticMarkup} from 'react-dom/server';

import Alert from 'spa/Components/Alert';
import {withConfig, withI18n} from 'spa/Components/Context';

import {cn} from 'spa/css';

import AddressSectionWrapper from '../AddressSectionWrapper';
import AppsLinks from 'spa/Components/AppsLinks';
import TrustPilotReview from 'spa/Components/TrustPilotReview';

import '../home-top-section-new.less';

@inject(({
  store: {
    i18n,
    notifications,
    session,
  },
}) => (
  {
    i18n,
    notifications,
    session,
  }
))
@observer
@withConfig
@withI18n
class HomeTopSectionNew extends React.Component {
  static propTypes = {
    isLandingPage: PropTypes.bool,
    notifications: PropTypes.shape({
      add: PropTypes.func.isRequired,
    }).isRequired,
    session: PropTypes.shape({
      isLoggedIn: PropTypes.bool,
    }).isRequired,
    subTitle: PropTypes.string,
    title: PropTypes.string,
    trackingCategory: PropTypes.string,
    trackingLocation: PropTypes.string,
  };

  UNSAFE_componentWillMount() {
    const {config, i18n} = this.context;

    this.showTrustPilotReviews = config.getValue('b2c.show-trustpilot-reviews', i18n.umRegion);
    this.showPhoneNumber = config.getValue('b2c.show-home-phone-number', i18n.umRegion);
    this.phoneNumberHuman = this.showPhoneNumber ? config.getValue('locale.telephone-human', i18n.umRegion) : null;
    this.phoneNumberFormatted = this.showPhoneNumber ? config.getValue('locale.telephone-formatted', i18n.umRegion) : null;
  }

  render() {
    const {i18n} = this.context;
    const {
      isLandingPage,
      subTitle,
      title,
      trackingCategory,
      trackingLocation,
    } = this.props;
    const {phoneNumberHuman, phoneNumberFormatted, showTrustPilotReviews} = this;

    return (
      <section className="home-top-section-new">
        <div
          className={cn(
            'home-top-section-new__stores-links-container',
            isLandingPage && 'home-top-section-new__stores-links-container--landing-page',
          )}
        >
          <AppsLinks
            firstLinkClassname="home-top-section-new__store-image home-top-section-new__store-image--with-margin"
            onClickLink={this.onClickStoreLink}
            secondLinkClassname="home-top-section-new__store-image"
          />
        </div>
        <div className="home-top-section-new__text-container">
          <div className="row">
            <AddressSectionWrapper
              isLandingPage={isLandingPage}
              phoneNumberHuman={phoneNumberHuman}
              phoneNumberFormatted={phoneNumberFormatted}
              roundInputBox
              subTitle={subTitle}
              trackingCategory={trackingCategory}
              trackingLocation={trackingLocation}
              title={title}
            />
            <noscript
              dangerouslySetInnerHTML={{
                __html: renderToStaticMarkup(<Alert type="error" title={i18n.__('Booking is only supported with javascript enabled.')} />),
              }}
            />
          </div>
          <div
            className={cn(
              'home-top-section-new__trustpilot',
              i18n.lc !== 'en-gb' && 'home-top-section__press-featured',
            )}>
            {showTrustPilotReviews ? (
              <div>
                <TrustPilotReview
                  linkText={i18n._x(
                    'Urban on Trustpilot',
                    'Trustpilot default link text',
                  )}
                  locale={i18n.locale}
                  theme="dark"
                />
              </div>
            ) : null}
          </div>
        </div>
        <div className="home-top-section-new__image-container">
          <img
            alt={i18n._x('Person receiving a massage by an Urban practitioner', 'Homepage alt text')}
            className="home-top-section-new__image"
            srcSet="
              https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,g_south,c_fill,w_400,h_194/v1644310861/b2c-art/home-2022/home-top.jpg 400w,
              https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,g_south,c_fill,w_512,h_248/v1644310861/b2c-art/home-2022/home-top.jpg 512w,
              https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,g_south,c_fill,w_768,h_372/v1644310861/b2c-art/home-2022/home-top.jpg 768w,
              https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,g_south,c_fill,w_1024,h_496/v1644310861/b2c-art/home-2022/home-top.jpg 1024w,
              https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,g_south,c_fill,w_1280,h_620/v1644310861/b2c-art/home-2022/home-top.jpg 1280w,
              https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,g_south,c_fill,w_2000,h_969/v1644310861/b2c-art/home-2022/home-top.jpg 2000w"
            src="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,g_south,c_fill,w_1280,h_620/v1644310861/b2c-art/home-2022/home-top.jpg"
            sizes="(min-width: 76.8rem) 127rem, 100vw "
          />
        </div>
      </section>
    );
  }
}

export default HomeTopSectionNew;



// WEBPACK FOOTER //
// ./spa/Pages/Home2020/digital/HomeTopSectionNewForDigital.jsx